import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_LESSON_TYPES_CURRENT_STUDENT } from '@/api/endpoints';
import { LESSON_TYPES_QUERY_KEY } from '@/api/queryKeys';
import { useStudyYearPeriods } from '@/pages/Overview/hooks/useStudyYearPeriods';
import { getDefaultPeriod } from '@/pages/Overview/period';
import type { StudentLessonType } from '@/types/ratings';
import { unwrapAxiosResponse } from '@/utils/axios';
import { toApiDate } from '@/utils/date';

export const useLessonTypes = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { periods, arePeriodsLoading } = useStudyYearPeriods();
  const yearPeriod = getDefaultPeriod(periods);
  const from = toApiDate(yearPeriod.from);
  const to = toApiDate(yearPeriod.to);

  return useQuery<StudentLessonType[]>({
    queryKey: [...LESSON_TYPES_QUERY_KEY, from, to],
    enabled: enabled && !arePeriodsLoading,
    staleTime: Infinity,
    queryFn: () =>
      apiClient
        .get<StudentLessonType[]>(API_LESSON_TYPES_CURRENT_STUDENT, {
          params: {
            'datePeriodModel.from': from,
            'datePeriodModel.to': to,
          },
        })
        .then(unwrapAxiosResponse),
  });
};
